import {useResources} from '@/di/di.root-container.hooks';

import React, {useState} from 'react';

import {ButtonLink, ButtonLinkMods} from '@/ui/kit/ButtonLink/ButtonLink';
import {ClientOnlyPortal} from '@/ui/kit/ClientOnlyPortal/ClientOnlyPortal';
import {CloseIcon} from '@/ui/kit/Icons/CloseIcon';

import s from './ProjectFinishedModal.module.css';

export function ProjectFinishedModal(): JSX.Element | null {
  const [isOpened, setOpened] = useState(true);
  const {
    content: {
      ClosedModal: {title, description, button},
    },
  } = useResources();

  const handleCloseModal = (): void => {
    setOpened(false);
  };

  if (!isOpened) return null;

  return (
    <ClientOnlyPortal selector="body">
      <div className={s.overlay}>
        <div className={s.content}>
          <div className={s.wrapper}>
            <CloseIcon className={s.img} />
            <p className={s.title}>{title}</p>
            <p className={s.description}>{description}</p>
            <ButtonLink mod={ButtonLinkMods.ButtonYellow} onClick={handleCloseModal} className={s.button}>
              <p className={s.buttonText}>{button}</p>
            </ButtonLink>
          </div>
        </div>
      </div>
    </ClientOnlyPortal>
  );
}
